import { render, staticRenderFns } from "./index.vue?vue&type=template&id=12514ca2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=12514ca2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12514ca2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12514ca2')) {
      api.createRecord('12514ca2', component.options)
    } else {
      api.reload('12514ca2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=12514ca2&scoped=true", function () {
      api.rerender('12514ca2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-render/index.vue"
export default component.exports